import { render } from "./CookieBanner.vue?vue&type=template&id=52386d5a&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=52386d5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52386d5a"]])

export default __exports__